<template>
  <div class="common-empty-record">
    <i class="iconfont">&#xe636;</i>
    <p>{{ $t('noMore') }}</p>
  </div>
</template>

<script>

export default {
  name: 'EmptyRecord',
  data() {
    return {

    }
  },
  props: {

  },
  methods: {

  }
}
</script>
